import React from "react";
import Blog_53 from "../component/Blog_53";
function Blog_53_container() {
  return <Blog_53 />;
}

export default Blog_53_container;
